import { ChangeDetectorRef, Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IEvents } from 'src/app/domain/registration/models/IEvents';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { EventsCESComponent } from '../crud-ces/crud-ces.component';
import {
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { getEventsTypeDescriptionByValue } from 'src/app/domain/registration/enums/events-type.enum';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { EventsService } from '../crud-service';
import { QrCodeDialogComponent } from '../qr-code-dialog/qr-code-dialog.component';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';
import { FormEventComponent } from '../form-event/form-event.component';
import { MeetingEventComponent } from '../meeting-event/meeting-event.component';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
  selector: 'app-events-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [EventsService],
})
export class EventsCrudIndex
  extends AbstractCrudIndex<IEvents>
  implements ITableResponsive {
  override title = 'EVENTOS';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;
  public filterFormValues: any = null
  currentTab: string = 'events';
  userType: string = '';
  constructor(
    public override dialog: MatDialog,
    public override service: EventsService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router,
    protected cdr: ChangeDetectorRef,
    protected authService: AuthService,
    public permissionService: PermissionService,
  ) {
    super(dialog, service, toastService, mediaObserver, router);

    this.userType = this.authService.isPartner() ? 'partner' : 'admin';
    this.currentTab = 'events';

    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_WEB
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  override loadList() {
    const params = this.params;

    this.service.getAllEvents(params).subscribe({
      next: ([data, length]) => {
        this.length = length;

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            return {
              ...item,
              event: item.event ? item.event.id : null,
              meetingId: item.meeting ? item.meeting.id : null,
              system: item.meeting ? item.meeting.system : null,
              type: getEventsTypeDescriptionByValue(item.type),
              createdAt: moment(item.createdAt).format('DD/MM/YYYY')
            };
          })
        );

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Erro ao carregar eventos:', error);
      },
    });
  }

  openQrCode(event: IEvents): void {
    const qrCodeUrl = this.createQRCodeUrl(event);
    const dialogRef = this.dialog.open(QrCodeDialogComponent, {
      data: { qrCodeUrl, linkText: qrCodeUrl },
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  createQRCodeUrl(event: IEvents): string {
    return `gmtadmin.grupomegatech.com.br/form-event/${event.id}`;
  }

  openShow(element: any) {
    if (!element.id) {
      console.error('Erro: ID do evento está indefinido.');
      return;
    }
    this.service.getEventById(element.id.toString()).subscribe({
      next: (eventData) => {
        console.log('📥 Evento carregado para exibição:', eventData);
        GlobalUtils.openDialog({
          dialog: this.dialog,
          dialogConfig: {
            width: '50%',
            height: '90vh',
            maxHeight: '90vh',
            panelClass: 'custom-dialog-container',
            disableClose: false,
          },
          component: FormEventComponent,
          data: { type: TypeCesEnum.SHOW, element: eventData },
          callBack: (data: any) => {
            if (data?.changeType === TypeCesEnum.EDIT) {
              this.openEdit(element);
            }
            if (data?.result) {
              this.openDelete(element);
            }
          },
        });
      },
      error: (error) => {
        console.error('Erro ao carregar evento para exibição:', error);
      },
    });
  }

  openShowMeeting(element: any) {
    if (!element.id) {
      console.error('Erro: ID do evento está indefinido (openShowMeeting).');
      return;
    }

    this.service.getEventById(element.id.toString()).subscribe({
      next: (eventData) => {
        console.log('📥 Evento carregado para exibição (MEETING):', eventData);

        GlobalUtils.openDialog({
          dialog: this.dialog,
          dialogConfig: {
            width: '40%',
            height: '90vh',
            maxHeight: '90vh',
            panelClass: 'custom-dialog-container',
            disableClose: false,
          },
          component: MeetingEventComponent,
          data: { type: TypeCesEnum.SHOW, element: element },
          callBack: (data: any) => {
            if (data?.changeType === TypeCesEnum.EDIT) {
              this.openEdit(element);
            }
            if (data?.result) {
              this.openDelete(element);
            }
          },
        });
      },
      error: (error) => {
        console.error('Erro ao carregar evento (openShowMeeting):', error);
      },
    });
  }

  openNew(element: IEvents) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      dialogConfig: { width: '55%' },
      component: EventsCESComponent,
      data: { type: TypeCesEnum.NEW, element },
      callBack: (data: any) => {
        if (data?.element) {
          this.service.createEvent(data.element).subscribe({
            next: (response) => {
              this.toastService.showSuccess('Evento criado com sucesso!');
              this.loadList();
            },
            error: (error) => {
              console.error('Erro ao criar evento:', error);
              this.openNew(data.element);
            },
          });
        }
      },
    });
  }

  openEdit(element: IEvents) {
    if (!element.id) {
      console.error('Erro: ID do evento está indefinido.');
      return;
    }

    this.service.getEventById(element.id.toString()).subscribe({
      next: (eventData) => {
        const openDialogWithEventData = (data: any) => {
          console.log('Abrindo diálogo com dados:', data);
          GlobalUtils.openDialog({
            dialog: this.dialog,
            dialogConfig: { width: '55%' },
            component: EventsCESComponent,
            data: { type: TypeCesEnum.EDIT, element: data },
            callBack: (result: any) => {
              if (result?.element?.id) {
                this.service.update(result.element.id, result.element).subscribe({
                  next: () => {
                    this.loadList();
                    this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED);
                  },
                  error: (error) => {
                    console.error('Erro ao atualizar evento:', error);
                  },
                });
              }

              if (result?.changeType === TypeCesEnum.SHOW) {
                this.openShow(element);
              }

              if (result?.result) {
                this.openDelete(element);
              }
            },
          });
        };

        // Verificar ambos os formatos: REUNIAO e REUNIÃO
        if (eventData.typeQuestion === 'REUNIAO' || eventData.typeQuestion === 'REUNIÃO') {
          if (!eventData.meeting && eventData.id) {
            console.log('Buscando dados da reunião para o evento:', eventData.id);
            
            this.service.getMeetingFromEvent(eventData.id).subscribe({
              next: (meetingData) => {
                console.log('Dados da reunião obtidos:', meetingData);
                eventData.meeting = meetingData;
                openDialogWithEventData(eventData);
              },
              error: (err) => {
                console.error('Erro ao carregar reunião para edição:', err);
                // Mesmo se ocorrer erro, abre o diálogo para permitir edição
                openDialogWithEventData(eventData);
              },
            });
          } else {
            console.log('Evento já possui dados de reunião:', eventData.meeting);
            openDialogWithEventData(eventData);
          }
        } else {
          openDialogWithEventData(eventData);
        }
      },
      error: (error) => {
        console.error('Erro ao carregar evento para edição:', error);
      },
    });
  }

  public resetFilter(): void {
    this.filterFormValues = null;
    localStorage.removeItem('parcllilterFormValues');

    this.isAdvancedFilterActive = false;
    this.lastAppliedFilter = null;
    this.params = { limit: 25, page: 0, filter: '' };

    const resetFields = this.filterFields.map(field => {
      if (field.type === TypeComponentFieldEnum.SLIDE_TOGGLE) {
        return { ...field, value: false };
      }
      return { ...field, value: '' };
    });

    this.filterFields = resetFields;

    this.loadList();
  }

}
